import { API_COMPOSER_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  Error,
  GetWebhookListParams,
  GetWebhooksListResponse
} from '@eggplant/types'

interface Props {
  params?: GetWebhookListParams
  onSuccess?: (webhook: GetWebhooksListResponse) => void
  onError?: (error: Error) => void
  children?: () => React.ReactNode
}

const GetComposerWebhooksRequest = ({
  params,
  onSuccess,
  onError,
  children
}: Props) => {
  const url = `${API_COMPOSER_SERVICE}/webhooks`

  const { requestParams } = useGetParamsWithSpaceId<GetWebhookListParams|undefined>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default GetComposerWebhooksRequest
